// Entrypoint, gebündelt von esbuild nach app/assets/builds/application.js
import "@hotwired/turbo-rails"

import Tooltip from 'bootstrap/js/src/tooltip'
import Dropdown from 'bootstrap/js/src/dropdown'
import Collapse from 'bootstrap/js/src/collapse'
import Alert from 'bootstrap/js/src/alert'

document.addEventListener("turbo:load", function() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
})
